import React from 'react';

interface DownIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const DownIcon: React.FC<DownIconProps> = ({ width = 24, height = 24, fill = '#0D0D0D', className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.4 9.4L12 14L16.6 9.4L18 10.8L12 16.8L6 10.8L7.4 9.4Z"
        fill={fill}
      />
    </svg>
  );
};

export default DownIcon;


